import { render, staticRenderFns } from "./MiniviewName.vue?vue&type=template&id=83d28c76"
import script from "./MiniviewName.vue?vue&type=script&lang=js"
export * from "./MiniviewName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports